import get from "lodash/get";
import omit from "lodash/omit";
import round from "lodash/round";
import React from "react";
import convert from "convert-units";
import escapeName from "../../utils/escape-form-name";
import { RillContext } from "../../rill/RillReact/share/base";

const numberReg = /-?(\d+(\.\d*)?)?/;
const notNumberReg = /[^-\.0-9]/g;

class UnitInput extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.cleanNumber = this.cleanNumber.bind(this);
  }

  UNSAFE_componentWillReceiveProps(next) {
    const { units } = get(this.props, "units", false)
      ? this.props
      : this.context.locals;
    const { defaultValue, metric } = next;
    if (defaultValue !== this.props.defaultValue) {
      const { input } = this.refs;
      input.defaultValue = round(
        convert(defaultValue).from(metric).to(next[units]),
        2
      );
      delete input.value;
    }
  }

  cleanNumber({ target }) {
    //   Commented this line because the user was not able to erase the input
    //     if (target.value === "" || target.value == null) return;
    const value = target.value.replace(notNumberReg, "");
    const match = (value.match(numberReg) || [])[0];
    if (target.value !== match) target.value = match;
    if (this.props.handleChange) {
      this.props.handleChange(target);
    }
  }

  render() {
    const { units } = get(this.props, "units", false)
      ? this.props
      : this.context.locals;
    const { name, defaultValue, metric, imperial } = this.props;
    const onProgramEditor = Boolean(this.props.onProgramEditor);
    const value =
      defaultValue &&
      round(convert(defaultValue).from(metric).to(this.props[units]), 2);
    const path = escapeName(name);
    const handleUnitChange = this.props.handleUnitChange;
    const { hidden } = this.props;

    return (
      <div className={`unit-input ${hidden && "hidden"}`}>
        <input
          ref="input"
          className="text-input"
          inputMode="numeric"
          pattern="-?\d+(\.\d+)?"
          data-name={path}
          {...omit(this.props, [
            "metric",
            "imperial",
            "handleUnitChange",
            "onProgramEditor",
            "units",
          ])}
          onChange={this.cleanNumber}
          defaultValue={value}
          sz="large"
        />

        <div className="units-toggle">
          <input
            type="hidden"
            name={`${onProgramEditor ? "" : "_"}units[${path}][metric]`}
            value={metric}
          />

          <input
            type="hidden"
            name={`_units[${path}][imperial]`}
            value={imperial}
          />

          <label>
            <input
              ref="metric"
              type="radio"
              name={`${onProgramEditor ? "" : "_"}units[${path}][type]`}
              key={this.props.units}
              defaultChecked={units === "metric"}
              defaultValue="metric"
              onChange={handleUnitChange}
            />
            <b>{metric}</b>
          </label>

          <label>
            <input
              ref="imperial"
              type="radio"
              name={`${onProgramEditor ? "" : "_"}units[${path}][type]`}
              key={this.props.units}
              defaultChecked={units !== "metric"}
              defaultValue="imperial"
              onChange={handleUnitChange}
            />
            <b>{imperial}</b>
          </label>
        </div>
      </div>
    );
  }
}

UnitInput.contextType = RillContext;

export default UnitInput;
